export const CHART_HLE_HITS = 'CHART_HLE_HITS';
export const CHART_HLE_LATENCY = 'CHART_HLE_LATENCY';
export const CHART_HLE_ERROR_RATE = 'CHART_HLE_ERROR_RATE';

export const HISTORICAL_METRIC_30DAYS = 'HISTORICAL_METRIC_30DAYS';
export const HISTORICAL_METRIC_52WEEKS = 'HISTORICAL_METRIC_52WEEKS';

export const CHART_ELEMENT_LINE = 'CHART_ELEMENT_LINE';
export const CHART_ELEMENT_AREA = 'CHART_ELEMENT_AREA';

export const CHART_QUOTA_DAILY = 'CHART_QUOTA_DAILY';
export const CHART_QUOTA_HOURLY = 'CHART_QUOTA_HOURLY';
export const CHART_QUOTA_MONTHLY = 'CHART_QUOTA_MONTHLY';